import { Plugin, keymap } from '@progress/kendo-angular-editor';
import { TextSelection } from 'prosemirror-state';

export const editorPlugins = (defaultPlugins: Plugin[]): Plugin[] => {
  const shiftEnter: Plugin = keymap({
    Enter: (state, dispatch) => {
      const tr = state.tr.replaceSelectionWith(state.schema.node('hard_break'));

      const newPos = tr.selection.anchor;
      tr.setSelection(TextSelection.create(tr.doc, newPos));

      if (!tr || !dispatch) {
        return false;
      }

      dispatch(tr);
      return true;
    },
  });

  return [shiftEnter, ...defaultPlugins];
};
